<template>
  <div class="container">
    <!-- <v-slider
      min="1"
      max="300"
      thumb-label
      v-model="localRoundelScale"
    ></v-slider> -->
    <div class="roundels">
      <div v-for="roundel in roundels" :key="roundel" style="width: 80px">
        <img
          class="roundel"
          :src="assetPath(roundel)"
          :width="roundelRatio(roundel) * 32"
          height="32"
          v-on:click="setRoundel(roundel)"
          :title="roundel"
          style="filter: drop-shadow(3px 3px 3px #00000055)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import roundels from "@/data/roundels.js";

export default {
  props: ["value", "roundelScale"],

  data() {
    return {
      localRoundel: this.value,
      localRoundelScale: this.roundelScale,
      roundels,
      roundelsRatios: {
        us: 204.0 / 108,
        us_low: 204.0 / 108,
        us_white: 204.0 / 108,
        korea: 1160 / 481.4,
        korea_low: 1160 / 481.4,
        china: 1811.56494 / 720.33002,
        china_low: 1811.56494 / 720.33002,
        hungary: 1200 / 643.57,
        peru_navy: 600 / 900,
      },
    };
  },
  methods: {
    assetPath(roundel) {
      var images = require.context("@/assets/roundels", false, /\.svg$/);
      return images("./" + roundel + ".svg");
    },
    setRoundel(roundel) {
      this.$emit("input", roundel);
    },
    setRoundelScale(scale) {
      this.localRoundelScale = scale;
      this.$emit("changeRoundelScale", scale);
    },
    roundelRatio(id) {
      var ratio = this.roundelsRatios[id];
      if (ratio === undefined) {
        return 1.0;
      }
      return ratio;
    },
  },
  watch: {
    localRoundelScale: {
      handler(value) {
        this.setRoundelScale(value);
      },
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  align-items: top;
  justify-content: center;
  flex-direction: column;
}
.roundel {
  margin: 5px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.roundels {
  display: flex;
  flex-flow: wrap;
  padding: 5px;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
}
</style>
